// extracted by mini-css-extract-plugin
module.exports = {"SeriesLegend":"Series_SeriesLegend__drecE"};